import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "o-propertyGallery__grid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "154",
  height: "35",
  viewBox: "0 0 154 35",
  fill: "none",
  class: "o-propertyGallery__danboligLogo"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M17.1035 29.347C14.6416 29.9949 11.791 30.3836 9.32916 30.3836C3.10972 30.3836 0 26.7556 0 20.6657V17.6856C0 11.5957 2.98015 7.96768 9.32916 7.96768C10.2362 7.96768 11.6615 8.09725 13.0867 8.22683V1.35952C13.0867 0.970808 13.4755 0.582092 13.8642 0.582092H17.4922C17.8809 0.582092 18.2696 0.970808 18.2696 1.35952V28.3104C18.14 28.9583 18.0105 29.0879 17.1035 29.347ZM12.9572 12.3731C11.9206 12.2436 10.2362 12.114 9.32916 12.114C5.9603 12.114 5.18287 14.4463 5.18287 17.6856V20.6657C5.18287 23.7754 5.9603 26.2373 9.32916 26.2373C10.7545 26.2373 12.3093 26.1077 13.0867 25.9782V12.3731H12.9572Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M38.6122 30.1246H35.3729C34.9842 30.1246 34.5955 29.7359 34.5955 29.3472V28.6993C32.7815 29.7359 30.9674 30.3837 29.1534 30.3837C25.9141 30.3837 22.4157 29.088 22.4157 23.9052V23.7756C22.4157 19.3701 25.1367 17.0379 31.8745 17.0379H34.3363V15.3534C34.3363 12.8916 33.1702 12.2437 30.9674 12.2437C28.5056 12.2437 25.9141 12.3733 24.6184 12.5028H24.4889C24.1001 12.5028 23.841 12.3733 23.841 11.855V9.39312C23.841 9.00441 24.1001 8.74526 24.6184 8.61569C26.1733 8.35655 28.376 7.96783 31.097 7.96783C36.539 7.96783 39.6488 10.4297 39.6488 15.3534V29.3472C39.3896 29.7359 39.0009 30.1246 38.6122 30.1246ZM34.2067 20.4067H31.7449C28.2464 20.4067 27.469 21.5729 27.469 23.646V23.7756C27.469 25.7192 28.376 26.2375 30.3196 26.2375C31.7449 26.2375 33.1702 25.7192 34.3363 25.2009V20.4067H34.2067Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M61.5468 30.1246H57.9188C57.5301 30.1246 57.1414 29.7359 57.1414 29.3472V16.6491C57.1414 13.2803 56.8822 12.2437 53.9021 12.2437C52.6064 12.2437 51.1811 12.762 49.4967 13.669V29.2176C49.4967 29.6063 49.1079 29.995 48.7192 29.995H45.0912C44.7025 29.995 44.3138 29.6063 44.3138 29.2176V9.00441C44.3138 8.61569 44.7025 8.22698 45.0912 8.22698H48.4601C48.8488 8.22698 49.2375 8.61569 49.2375 9.00441V9.78184C51.4402 8.35655 52.9951 7.96783 55.4569 7.96783C61.0285 7.96783 62.1947 11.7254 62.1947 16.6491V29.3472C62.3243 29.7359 61.9355 30.1246 61.5468 30.1246Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M76.1882 30.3836C73.7263 30.3836 70.7462 29.9949 68.4139 29.347C67.5069 29.0879 67.3773 28.8287 67.3773 28.3104V1.35952C67.3773 0.970808 67.766 0.582092 68.1547 0.582092H71.7828C72.1715 0.582092 72.5602 0.970808 72.5602 1.35952V8.22683C73.9855 8.09725 75.4108 7.96768 76.3178 7.96768C82.5372 7.96768 85.6469 11.5957 85.6469 17.6856V20.6657C85.5174 26.7556 82.4076 30.3836 76.1882 30.3836ZM80.3345 17.6856C80.3345 14.4463 79.5571 12.114 76.1882 12.114C75.2812 12.114 73.5968 12.2436 72.4306 12.3731V25.8486C73.208 25.9782 74.7629 26.1077 76.1882 26.1077C79.5571 26.1077 80.3345 23.7754 80.3345 20.5361V17.6856Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M98.3448 30.3838C92.2549 30.3838 89.0156 26.2375 89.0156 20.6659V17.5562C89.0156 11.9846 92.2549 7.83832 98.3448 7.83832C104.435 7.83832 107.674 11.9846 107.674 17.5562V20.6659C107.674 26.2375 104.435 30.3838 98.3448 30.3838ZM102.491 17.5562C102.491 14.3169 101.066 12.3733 98.3448 12.3733C95.6238 12.3733 94.1985 14.4465 94.1985 17.5562V20.6659C94.1985 23.9052 95.6238 25.8488 98.3448 25.8488C101.066 25.8488 102.491 23.7756 102.491 20.6659V17.5562Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M116.614 30.1245H112.986C112.597 30.1245 112.209 29.7357 112.209 29.347V1.35952C112.209 0.970808 112.597 0.582092 112.986 0.582092H116.614C117.003 0.582092 117.392 0.970808 117.392 1.35952V29.347C117.262 29.7357 117.003 30.1245 116.614 30.1245Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M127.11 5.24679H123.353C122.964 5.24679 122.575 4.85807 122.575 4.46936V1.10049C122.575 0.711774 122.964 0.323059 123.353 0.323059H127.11C127.499 0.323059 127.888 0.711774 127.888 1.10049V4.46936C127.888 4.98764 127.629 5.24679 127.11 5.24679ZM126.981 30.1246H123.353C122.964 30.1246 122.575 29.7358 122.575 29.3471V9.00437C122.575 8.61565 122.964 8.22694 123.353 8.22694H126.981C127.369 8.22694 127.758 8.61565 127.758 9.00437V29.3471C127.758 29.7358 127.499 30.1246 126.981 30.1246Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFFFFF",
    d: "M150.692 8.22691H144.861C143.825 7.96776 142.529 7.70862 141.104 7.70862C134.625 7.70862 132.293 10.4296 132.163 15.0942V17.1674C132.163 19.8884 133.07 21.9615 135.143 23.1277C134.107 23.9051 132.811 25.0712 132.811 26.8852C132.811 29.7358 133.977 30.7724 137.217 31.1611C140.067 31.4202 141.104 31.6794 143.695 31.9385C145.38 32.0681 145.768 32.3272 145.768 33.7525C145.768 34.0117 145.768 34.1413 145.768 34.2708C145.768 34.53 145.768 34.6595 146.027 34.6595C146.287 34.6595 150.174 34.6595 150.562 34.6595C150.822 34.6595 150.822 34.6595 150.951 34.2708C150.951 34.0117 150.951 33.4934 150.951 33.2343C150.951 29.995 149.785 28.3105 146.157 27.7922C143.566 27.5331 142.14 27.4035 139.678 27.1444C138.771 27.0148 138.383 26.7557 138.383 26.2374C138.383 25.5895 139.031 24.9417 139.678 24.4234C140.067 24.4234 140.456 24.4234 140.974 24.4234C147.194 24.4234 149.915 21.7024 149.915 17.1674V15.0942C149.915 13.7985 149.655 12.6323 149.137 11.5958C149.655 11.4662 150.303 11.3366 150.951 11.0775C151.34 10.9479 151.599 10.6888 151.599 10.1705V8.87476C151.729 8.35648 151.469 8.22691 150.692 8.22691ZM145.639 17.2969C145.639 19.8884 144.343 20.9249 141.104 20.9249C137.994 20.9249 136.698 19.8884 136.698 17.2969V15.2238C136.698 12.6323 137.864 11.4662 141.104 11.4662C144.473 11.4662 145.639 12.6323 145.639 15.2238V17.2969Z"
  })
], -1 /* HOISTED */)
const _hoisted_3 = { class: "o-propertyGallery__galleryImages" }
const _hoisted_4 = ["id", "textContent"]
const _hoisted_5 = ["src", "srcset", "alt", "width", "height", "aria-labelledby", "data-index"]
const _hoisted_6 = { class: "o-propertyGallery__galleryThumbnailImages" }
const _hoisted_7 = ["data-index", "onClick"]
const _hoisted_8 = { class: "o-propertyGallery__actions" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_image_gallery_thumbnail = _resolveComponent("m-image-gallery-thumbnail")!
  const _component_a_icon = _resolveComponent("a-icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      ($data.isVisible)
        ? (_openBlock(), _createElementBlock("dialog", {
            key: 0,
            ref: "galleryDialog",
            class: _normalizeClass(["o-propertyGallery", { fullscreen: $data.isFullscreen }])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.galleryItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("div", {
                      class: "a-label o-propertyGallery__imageDescription",
                      id: `image-description-${index}`,
                      textContent: _toDisplayString(
                                `${index + 1} / ${$data.galleryItems.length} ${item.description}`
                            )
                    }, null, 8 /* PROPS */, _hoisted_4),
                    _createElementVNode("img", {
                      src: `${item.url}&width=800`,
                      srcset: `${item.url}&width=800 800w, ${item.url}&width=1400 1400w, ${item.url}&width=2000 2000w, ${item.url}&width=2600 2600w, ${item.url}&width=3000 3000w`,
                      alt: item.description,
                      width: item.width,
                      height: item.height,
                      "aria-labelledby": `image-description-${index}`,
                      "data-index": `${index}`,
                      sizes: "70vw"
                    }, null, 8 /* PROPS */, _hoisted_5)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.galleryItems, (item, itemIndex) => {
                  return (_openBlock(), _createElementBlock("li", { key: itemIndex }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "thumb-button",
                      "data-index": `${itemIndex}`,
                      onClick: ($event: any) => ($options.onClick(itemIndex))
                    }, [
                      _createVNode(_component_m_image_gallery_thumbnail, {
                        url: item.url,
                        width: item.width,
                        height: item.height,
                        index: itemIndex,
                        alt: item.description
                      }, null, 8 /* PROPS */, ["url", "width", "height", "index", "alt"])
                    ], 8 /* PROPS */, _hoisted_7)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_8, [
                (!$data.isFullscreen)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      "aria-label": $props.texts.screenReaderClose,
                      class: "m-button o-propertyGallery__closeButton",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.close()))
                    }, [
                      _createVNode(_component_a_icon, {
                        class: "o-propertyGallery__closeIcon",
                        name: "close"
                      })
                    ], 8 /* PROPS */, _hoisted_9))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": 
                            $data.isFullscreen
                                ? $props.texts.closeFullScreen
                                : $props.texts.openFullScreen
                        ,
                  class: "m-button m-button--dark o-propertyGallery__fullscreenButton",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.toggleFullScreen()))
                }, [
                  (!$data.isFullscreen)
                    ? (_openBlock(), _createBlock(_component_a_icon, {
                        key: 0,
                        class: "o-propertyGallery__closeIcon",
                        name: "fullscreen"
                      }))
                    : _createCommentVNode("v-if", true),
                  ($data.isFullscreen)
                    ? (_openBlock(), _createBlock(_component_a_icon, {
                        key: 1,
                        class: "o-propertyGallery__closeIcon",
                        name: "fullscreen_exit"
                      }))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_10),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Forrige",
                  class: _normalizeClass(["m-button o-propertyGallery__prevButton", {
                            'm-button--transparent': !$data.isFullscreen,
                            'm-button--shadowed': $data.isFullscreen,
                        }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.prev()))
                }, [
                  _createVNode(_component_a_icon, {
                    class: "o-propertyGallery__closeIcon",
                    name: "arrow_upward"
                  })
                ], 2 /* CLASS */),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Næste",
                  class: _normalizeClass(["m-button o-propertyGallery__nextButton", {
                            'm-button--transparent': !$data.isFullscreen,
                            'm-button--shadowed': $data.isFullscreen,
                        }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.next()))
                }, [
                  _createVNode(_component_a_icon, {
                    class: "o-propertyGallery__closeIcon",
                    name: "arrow_downward"
                  })
                ], 2 /* CLASS */)
              ])
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ], undefined, true),
    _: 1 /* STABLE */
  }))
}